<div class="mat-typography notice-info">
  <mat-icon class="notice-info__icon">{{icon}}</mat-icon>
  <span class="notice-info__text">{{message}}</span>
</div>
